const BLUE = "#404FCF";
const LIGHT_BLUE = "#9CA3E6";
const GREEN = "#2BBA99";
const GRAY = "#606060";
const YELLOW = "#F7B04D";
const RED = "#F45B69";
const BLACK = "#000000";

const metricsColors = {
  BLUE,
  LIGHT_BLUE,
  GREEN,
  GRAY,
  YELLOW,
  RED,
  BLACK
};

export default metricsColors;
